import { AppUserType } from "../../../Models/AppUserType";

const initialState: AppUserType = {
  id: "",
  isPredUser: false,
  isGredUser: false,
  email: "",
  name: "",
  lastFilter: "",
  roles: [],
  timezone: "",
  googleCalendarId: "",
  redPandaProjects: null,
  sharedFilters: null,
  sharedDisplays: null,
  userFilters: null,
};

export default initialState;
